import {fetch} from "utils/dataAccess";

export default async function list(params = "pagination=false&order[createdAt]=desc") {
    const response = await fetch(`/notifications?${params}`);

    if (!response.ok) throw new Error('Failed to retrieve notifications');

    return (await response.json())['hydra:member'];
}
